// Google Authentication configuration for Azure Static Web Apps
// Uses built-in SWA authentication with Google provider

export const authConfig = {
  loginUrl: "/.auth/login/google",
  logoutUrl: "/.auth/logout",
  userInfoUrl: "/.auth/me",
};

// Authorized admin email
export const AUTHORIZED_EMAIL = "scarpetta.homerestaurant@gmail.com";

// User info interface from SWA auth
export interface ClientPrincipal {
  identityProvider: string;
  userId: string;
  userDetails: string;
  userRoles: string[];
  claims?: { typ: string; val: string }[];
}

export interface AuthInfo {
  clientPrincipal: ClientPrincipal | null;
}

// Fetch current user info from SWA auth endpoint
export async function getUserInfo(): Promise<ClientPrincipal | null> {
  try {
    const response = await fetch(authConfig.userInfoUrl);
    if (response.ok) {
      const data: AuthInfo = await response.json();
      return data.clientPrincipal;
    }
  } catch (error) {
    console.error("Error fetching user info:", error);
  }
  return null;
}

// Get display name from claims (Google provides 'name' claim)
export function getUserDisplayName(user: ClientPrincipal): string {
  if (user.claims) {
    const nameClaim = user.claims.find(c => 
      c.typ === 'name' || 
      c.typ === 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'
    );
    if (nameClaim?.val) {
      return nameClaim.val;
    }
  }
  // Fallback to email without domain
  return user.userDetails?.split('@')[0] || user.userDetails;
}
